import type { Directory } from '../api/client';
import { DestinationPicker } from './pickers';

/**
 * Where calls to new numbers go (Get numbers, Move numbers to Stitch). With a number inventory
 * (1.13.0, Teampace 3035) the company can keep them in open inventory for now: callers hear the
 * company's name, and the numbers show as Open inventory on Numbers until they're pointed somewhere.
 */
export function NewNumbersGoTo({
  inventory,
  waiting,
  onWaiting,
  destination,
  onDestination,
  dir,
  company,
  error,
  many
}: {
  /** The company has open inventory. */
  inventory: boolean;
  waiting: boolean;
  onWaiting: (v: boolean) => void;
  destination: string;
  onDestination: (v: string) => void;
  dir: Directory | undefined;
  company: string;
  error?: string | undefined;
  many: boolean;
}) {
  const picker = (
    <DestinationPicker
      label="Calls go to"
      value={destination}
      onChange={onDestination}
      dir={dir}
      mode="account"
      clearable={false}
      error={error}
      help="A person, voicemail box, auto attendant, ring group, call queue or time of day rule."
    />
  );
  if (!inventory) return picker;
  return (
    <>
      <div className="segmented" role="radiogroup" aria-label="Where calls go">
        <label className={!waiting ? 'on' : ''}>
          <input type="radio" name="goes" checked={!waiting} onChange={() => onWaiting(false)} />
          Somewhere now
        </label>
        <label className={waiting ? 'on' : ''}>
          <input type="radio" name="goes" checked={waiting} onChange={() => onWaiting(true)} />
          Open inventory
        </label>
      </div>
      {waiting ? (
        <p className="muted inventory-explain">
          {many ? 'They wait' : 'It waits'} in open inventory: callers hear “Thank you for calling {company}. This number isn’t in use yet.” Choose where{' '}
          {many ? 'each one goes' : 'it goes'} on Numbers whenever you’re ready.
        </p>
      ) : (
        picker
      )}
    </>
  );
}
